import React, {
     Component
} from 'react'


class SpeakerFlag extends Component {


     getCountryImage(countryName) {

          var country = countryName.toLowerCase()

          country = country.replace(/-/gi, "");
          country = country.replace(/ /gi, "");
          country = country.replace(/\./gi, "");

          var arraySpecialCharacters = [
               [/[aáâã]/g, 'a'],
               [/[eéê]/g, 'e'],
               [/[ií]/g, 'i'],
               [/[oóõô]/g, 'o'],
               [/[uúü]/g, 'u']
          ];
          arraySpecialCharacters.forEach(function (a) {
               country = country.replace(a[0], a[1]);
          });


          switch (country) {
               case 'afganistan':
               case 'afghanistan':
                    return require("../../assets/resources/css/imgs/Flags/Afghanistan.png");
               case 'unionafricana':
               case 'africanunion':
                    return require("../../assets/resources/css/imgs/Flags/AfricanUnion.png");
               case 'albania':
                    return require("../../assets/resources/css/imgs/Flags/Albania.png");
               case 'algeria':
                    return require("../../assets/resources/css/imgs/Flags/Algeria.png");
               case 'samoaamericana':
               case 'americansamoa':
                    return require("../../assets/resources/css/imgs/Flags/AmericanSamoa.png");
               case 'andorra':
                    return require("../../assets/resources/css/imgs/Flags/Andorra.png");
               case 'angola':
                    return require("../../assets/resources/css/imgs/Flags/Angola.png");
               case 'anguilla':
                    return require("../../assets/resources/css/imgs/Flags/Anguilla.png");
               case 'antarctica':
               case 'antarctida':
                    return require("../../assets/resources/css/imgs/Flags/Antarctica.png");
               case 'antiguabarbuda':
                    return require("../../assets/resources/css/imgs/Flags/AntiguaBarbuda.png");
               case 'ligaarabe':
               case 'arableague':
                    return require("../../assets/resources/css/imgs/Flags/ArabLeague.png");
               case 'armenia':
                    return require("../../assets/resources/css/imgs/Flags/Armenia.png");
               case 'aruba':
                    return require("../../assets/resources/css/imgs/Flags/Aruba.png");
               case 'asean':
                    return require("../../assets/resources/css/imgs/Flags/ASEAN.png");
               case 'austria':
                    return require("../../assets/resources/css/imgs/Flags/Austria.png");
               case 'azerbaijan':
                    return require("../../assets/resources/css/imgs/Flags/Azerbaijan.png");

               case 'bahamas':
                    return require("../../assets/resources/css/imgs/Flags/Bahamas.png");
               case 'bahrain':
                    return require("../../assets/resources/css/imgs/Flags/Bahrain.png");
               case 'bangladesh':
                    return require("../../assets/resources/css/imgs/Flags/Bangladesh.png");
               case 'barbados':
                    return require("../../assets/resources/css/imgs/Flags/Barbados.png");
               case 'belarus':
                    return require("../../assets/resources/css/imgs/Flags/Belarus.png");

               case 'belize':
                    return require("../../assets/resources/css/imgs/Flags/Belize.png");
               case 'benin':
                    return require("../../assets/resources/css/imgs/Flags/Benin.png");
               case 'bangladesh':
                    return require("../../assets/resources/css/imgs/Flags/Bangladesh.png");
               case 'bermuda':
                    return require("../../assets/resources/css/imgs/Flags/Bermuda.png");
               case 'bosnia':
                    return require("../../assets/resources/css/imgs/Flags/BosniaHerzegovina.png");


               case 'botswana':
                    return require("../../assets/resources/css/imgs/Flags/Botswana.png");
               case 'brunei':
                    return require("../../assets/resources/css/imgs/Flags/Brunei.png");
               case 'burkinafaso':
                    return require("../../assets/resources/css/imgs/Flags/BurkinaFaso.png");
               case 'burundi':
                    return require("../../assets/resources/css/imgs/Flags/Burundi.png");
               case 'camboya':
               case 'cambodja':
                    return require("../../assets/resources/css/imgs/Flags/Cambodja.png");
               case 'camerun':
               case 'cameroon':
                    return require("../../assets/resources/css/imgs/Flags/Cameroon.png");
               case 'bulgaria':
                    return require("../../assets/resources/css/imgs/Flags/Bulgaria.png");
               case 'capoverde':
                    return require("../../assets/resources/css/imgs/Flags/CapeVerde.png");
               case 'caricom':
                    return require("../../assets/resources/css/imgs/Flags/CARICOM.png");
               case 'islascayman':
               case 'caymanislands':
                    return require("../../assets/resources/css/imgs/Flags/CaymanIslands.png");
               case 'republicaafricanacentral':
               case 'centralafricanrepublic':
                    return require("../../assets/resources/css/imgs/Flags/CentralAfricanRepublic.png");
               case 'chad':
                    return require("../../assets/resources/css/imgs/Flags/Chad.png");
               case 'cis':
                    return require("../../assets/resources/css/imgs/Flags/CIS.png");
               case 'commonwealth':
                    return require("../../assets/resources/css/imgs/Flags/Commonwealth.png");
               case 'comoros':
                    return require("../../assets/resources/css/imgs/Flags/Comoros.png");
               case 'congo-brazzaville':
                    return require("../../assets/resources/css/imgs/Flags/Congo-Brazzaville.png");
               case 'congo-kinshasa(zaire)':
                    return require("../../assets/resources/css/imgs/Flags/Congo-Kinshasa(Zaire).png");
               case 'islascook':
               case 'cookislands':
                    return require("../../assets/resources/css/imgs/Flags/CookIslands.png");
               case 'croacia':
               case 'croatia':
                    return require("../../assets/resources/css/imgs/Flags/Croatia.png");
               case 'chipre':
                    return require("../../assets/resources/css/imgs/Flags/Cyprus.png");
               case 'dinamarca':
               case 'denmark':
                    return require("../../assets/resources/css/imgs/Flags/Denmark.png");
               case 'djibouti':
                    return require("../../assets/resources/css/imgs/Flags/Djibouti.png");
               case 'dominica':
                    return require("../../assets/resources/css/imgs/Flags/Dominica.png");
               case 'republicadominicana':
               case 'dominicanrepublic':
                    return require("../../assets/resources/css/imgs/Flags/DominicanRepublic.png");
               case 'egipto':
               case 'egypt':
                    return require("../../assets/resources/css/imgs/Flags/Egypt.png");
               case 'elsalvador':
                    return require("../../assets/resources/css/imgs/Flags/ElSalvador.png");
               case 'inglaterra':
               case 'england':
                    return require("../../assets/resources/css/imgs/Flags/England.png");
               case 'Costa de Marfil':
               case 'coteivoire':
               case 'ivorycoast':
                    return require("../../assets/resources/css/imgs/Flags/CoteIvoire.png");
               case 'guineaecuatorial':
               case 'equatorialguinea':
                    return require("../../assets/resources/css/imgs/Flags/EquatorialGuinea.png");
               case 'eritrea':
                    return require("../../assets/resources/css/imgs/Flags/Eritrea.png");
               case 'estonia':
                    return require("../../assets/resources/css/imgs/Flags/Estonia.png");
               case 'etipia':
               case 'ethiopia':
                    return require("../../assets/resources/css/imgs/Flags/Ethiopia.png");
               case 'unioneuropea':
               case 'europeanunion':
                    return require("../../assets/resources/css/imgs/Flags/EuropeanUnion.png");
               case 'faroes':
                    return require("../../assets/resources/css/imgs/Flags/Faroes.png");
               case 'fiji':
                    return require("../../assets/resources/css/imgs/Flags/Fiji.png");
               case 'gabon':
                    return require("../../assets/resources/css/imgs/Flags/Gabon.png");
               case 'georgia':
                    return require("../../assets/resources/css/imgs/Flags/Georgia.png");
               case 'ghana':
                    return require("../../assets/resources/css/imgs/Flags/Ghana.png");
               case 'gibraltar':
                    return require("../../assets/resources/css/imgs/Flags/Gibraltar.png");
               case 'groenlandia':
               case 'greenland':
                    return require("../../assets/resources/css/imgs/Flags/Greenland.png");
               case 'granada':
               case 'grenada':
                    return require("../../assets/resources/css/imgs/Flags/Grenada.png");
               case 'guadalupe':
               case 'guadeloupe':
                    return require("../../assets/resources/css/imgs/Flags/Guadeloupe.png");
               case 'guam':
                    return require("../../assets/resources/css/imgs/Flags/Guam.png");
               case 'guernsey':
                    return require("../../assets/resources/css/imgs/Flags/Guernsey.png");
               case 'guinea-bisau':
                    return require("../../assets/resources/css/imgs/Flags/Guinea-Bissau.png");
               case 'guinea':
                    return require("../../assets/resources/css/imgs/Flags/Guinea.png");
               case 'guyana':
                    return require("../../assets/resources/css/imgs/Flags/Guyana.png");
               case 'haiti':
                    return require("../../assets/resources/css/imgs/Flags/Haiti.png");
               case 'indonesia':
               case 'indonezia':
                    return require("../../assets/resources/css/imgs/Flags/Indonezia.png");
               case 'honduras':
                    return require("../../assets/resources/css/imgs/Flags/Honduras.png");
               case 'hongkong':
                    return require("../../assets/resources/css/imgs/Flags/HongKong.png");
               case 'hungria':
               case 'hungary':
                    return require("../../assets/resources/css/imgs/Flags/Hungary.png");
               case 'islandia':
               case 'iceland':
                    return require("../../assets/resources/css/imgs/Flags/Iceland.png");
               case 'iran':
                    return require("../../assets/resources/css/imgs/Flags/Iran.png");
               case 'irak':
               case 'iraq':
                    return require("../../assets/resources/css/imgs/Flags/Iraq.png");
               case 'conferenciaislamica':
                    return require("../../assets/resources/css/imgs/Flags/IslamicConference.png");
               case 'islademan':
               case 'isleofman':
                    return require("../../assets/resources/css/imgs/Flags/IsleofMan.png");
               case 'jamaica':
                    return require("../../assets/resources/css/imgs/Flags/Jamaica.png");
               case 'jersey':
                    return require("../../assets/resources/css/imgs/Flags/Jersey.png");
               case 'jordania':
               case 'jordan':
                    return require("../../assets/resources/css/imgs/Flags/Jordan.png");
               case 'kazajistan':
               case 'kazakhstan':
                    return require("../../assets/resources/css/imgs/Flags/Kazakhstan.png");
               case 'kenia':
               case 'kenya':
                    return require("../../assets/resources/css/imgs/Flags/Kenya.png");
               case 'kiribati':
                    return require("../../assets/resources/css/imgs/Flags/Kiribati.png");
               case 'kosovo':
                    return require("../../assets/resources/css/imgs/Flags/Kosovo.png");
               case 'kuwait':
                    return require("../../assets/resources/css/imgs/Flags/Kuwait.png");
               case 'kirguistan':
               case 'kyrgyzstan':
                    return require("../../assets/resources/css/imgs/Flags/Kyrgyzstan.png");
               case 'laos':
                    return require("../../assets/resources/css/imgs/Flags/Laos.png");
               case 'letonia':
               case 'latvia':
                    return require("../../assets/resources/css/imgs/Flags/Latvia.png");
               case 'libano':
               case 'lebanon':
                    return require("../../assets/resources/css/imgs/Flags/Lebanon.png");
               case 'lesoto':
               case 'lesotho':
                    return require("../../assets/resources/css/imgs/Flags/Lesotho.png");
               case 'liberia':
                    return require("../../assets/resources/css/imgs/Flags/Liberia.png");
               case 'libia':
               case 'libya':
                    return require("../../assets/resources/css/imgs/Flags/Libya.png");
               case 'liechtenstein':
                    return require("../../assets/resources/css/imgs/Flags/Liechtenshein.png");
               case 'lituania':
               case 'lithuania':
                    return require("../../assets/resources/css/imgs/Flags/Lithuania.png");
               case 'luxemburgo':
               case 'luxembourg':
                    return require("../../assets/resources/css/imgs/Flags/Luxembourg.png");
               case 'macao':
                    return require("../../assets/resources/css/imgs/Flags/Macao.png");
               case 'macedonia':
                    return require("../../assets/resources/css/imgs/Flags/Macedonia.png");
               case 'madagascar ':
                    return require("../../assets/resources/css/imgs/Flags/Madagascar.png");
               case 'malawi':
                    return require("../../assets/resources/css/imgs/Flags/Malawi.png");
               case 'malasia':
               case 'malaysia':
                    return require("../../assets/resources/css/imgs/Flags/Malaysia.png");
               case 'maldivas':
               case 'Maldives':
                    return require("../../assets/resources/css/imgs/Flags/Maldives.png");
               case 'mali':
                    return require("../../assets/resources/css/imgs/Flags/Mali.png");
               case 'malta ':
                    return require("../../assets/resources/css/imgs/Flags/Malta.png");
               case 'islasmarshall':
               case 'marshallislands':
                    return require("../../assets/resources/css/imgs/Flags/MarshallIslands.png");
               case 'martinica':
               case 'martinique':
                    return require("../../assets/resources/css/imgs/Flags/Martinique.png");
               case 'mauritania':
                    return require("../../assets/resources/css/imgs/Flags/Mauritania.png");
               case 'mauricio':
                    return require("../../assets/resources/css/imgs/Flags/Mauritius.png");
               case 'micronesia':
                    return require("../../assets/resources/css/imgs/Flags/Micronesia.png");
               case 'moldavia':
                    return require("../../assets/resources/css/imgs/Flags/Moldova.png");
               case 'monaco':
                    return require("../../assets/resources/css/imgs/Flags/Monaco.png");
               case 'mongolia':
                    return require("../../assets/resources/css/imgs/Flags/Mongolia.png");
               case 'montenegro':
                    return require("../../assets/resources/css/imgs/Flags/Montenegro.png");
               case 'montserrat':
               case 'Morocco':
                    return require("../../assets/resources/css/imgs/Flags/Morocco.png");
               case 'mozambique':
                    return require("../../assets/resources/css/imgs/Flags/Mozambique.png");
               case 'birmania':
               case 'myanmar':
                    return require("../../assets/resources/css/imgs/Flags/Myanmar(Burma).png");
               case 'nato':
                    return require("../../assets/resources/css/imgs/Flags/NATO.png");
               case 'nauru':
                    return require("../../assets/resources/css/imgs/Flags/Nauru.png");
               case 'nepal':
                    return require("../../assets/resources/css/imgs/Flags/Nepal.png");
               case 'antillasneerlandesas':
               case 'netherlandsantilles':
                    return require("../../assets/resources/css/imgs/Flags/NetherlandsAntilles.png");
               case 'nuevacaledonia':
               case 'newcaledonia':
                    return require("../../assets/resources/css/imgs/Flags/NewCaledonia.png");
               case 'nuevazelanda':
               case 'newzealand':
                    return require("../../assets/resources/css/imgs/Flags/NewZealand.png");
               case 'nicaragua':
                    return require("../../assets/resources/css/imgs/Flags/Nicaragua.png");
               case 'niger':
                    return require("../../assets/resources/css/imgs/Flags/Niger.png");
               case 'nigeria':
                    return require("../../assets/resources/css/imgs/Flags/Nigeria.png");
               case 'republicaturcadelnortedechipre':
               case 'northerncyprus':
                    return require("../../assets/resources/css/imgs/Flags/NorthernCyprus.png");
               case 'irlandadelnorte':
               case 'northernireland':
                    return require("../../assets/resources/css/imgs/Flags/NorthernIreland.png");
               case 'movimientoolimpico':
               case 'olimpicmovement':
                    return require("../../assets/resources/css/imgs/Flags/OlimpicMovement.png");
               case 'oman':
                    return require("../../assets/resources/css/imgs/Flags/Oman.png");
               case 'opec':
                    return require("../../assets/resources/css/imgs/Flags/OPEC.png");
               case 'pakistan':
                    return require("../../assets/resources/css/imgs/Flags/Pakistan.png");
               case 'palaos':
               case 'palau':
                    return require("../../assets/resources/css/imgs/Flags/Palau.png");
               case 'palestina':
               case 'palestine':
                    return require("../../assets/resources/css/imgs/Flags/Palestine.png");
               case 'papuanuevaguinea':
               case 'papuanewguinea':
                    return require("../../assets/resources/css/imgs/Flags/PapuaNewGuinea.png");
               case 'filipinas':
               case 'philippines':
                    return require("../../assets/resources/css/imgs/Flags/Philippines.png");
               case 'qatar':
                    return require("../../assets/resources/css/imgs/Flags/Qatar.png");
               case 'redcross':
               case 'cruzroja':
                    return require("../../assets/resources/css/imgs/Flags/Red Cross.png");
               case 'reunion':
                    return require("../../assets/resources/css/imgs/Flags/Reunion.png");
               case 'rwanda':
                    return require("../../assets/resources/css/imgs/Flags/Rwanda.png");
               case 'santalucia':
               case 'saintlucia':
                    return require("../../assets/resources/css/imgs/Flags/SaintLucia.png");
               case 'samoa':
                    return require("../../assets/resources/css/imgs/Flags/Samoa.png");
               case 'sanmarino':
                    return require("../../assets/resources/css/imgs/Flags/SanMarino.png");
               case 'santotomeyprincipe':
                    return require("../../assets/resources/css/imgs/Flags/SaoTomePrincipe.png");
               case 'arabiasaudita':
               case 'saudiarabia':
                    return require("../../assets/resources/css/imgs/Flags/SaudiArabia.png");
               case 'senegal':
                    return require("../../assets/resources/css/imgs/Flags/Senegal.png");
               case 'serbia':
               case 'serbiaymontenegro':
               case 'serbiaandmontenegro':
                    return require("../../assets/resources/css/imgs/Flags/Serbia.png");
               case 'seychelles':
                    return require("../../assets/resources/css/imgs/Flags/Seychelles.png");
               case 'sierraleona':
               case 'sierraleone':
                    return require("../../assets/resources/css/imgs/Flags/Sierra Leone.png");
               case 'singapur':
               case 'singapore':
                    return require("../../assets/resources/css/imgs/Flags/Singapore.png");
               case 'eslovaquia':
               case 'slovakia':
                    return require("../../assets/resources/css/imgs/Flags/Slovakia.png");
               case 'eslovenia':
               case 'slovenia':
                    return require("../../assets/resources/css/imgs/Flags/Slovenia.png");
               case 'islassalomon':
               case 'solomonislands':
                    return require("../../assets/resources/css/imgs/Flags/SolomonIslands.png");
               case 'somalia':
                    return require("../../assets/resources/css/imgs/Flags/Somalia.png");
               case 'sudafrica':
               case 'southafrica':
                    return require("../../assets/resources/css/imgs/Flags/SouthAfrica.png");
               case 'srilanka':
                    return require("../../assets/resources/css/imgs/Flags/Sri Lanka.png");
               case 'sancristóbalynieves':
               case 'stkittsnevis':
                    return require("../../assets/resources/css/imgs/Flags/StKittsNevis.png");
               case 'sanvicenteylasgranadinas':
               case 'stvincentthegrenadines':
                    return require("../../assets/resources/css/imgs/Flags/StVincenttheGrenadines.png");
               case 'sudan':
                    return require("../../assets/resources/css/imgs/Flags/Sudan.png");
               case 'surinam':
                    return require("../../assets/resources/css/imgs/Flags/Suriname.png");
               case 'swaziland':
               case 'suazilandia':
                    return require("../../assets/resources/css/imgs/Flags/Swaziland.png");
               case 'siria':
               case 'syria':
                    return require("../../assets/resources/css/imgs/Flags/Syria.png");
               case 'tahiti':
                    return require("../../assets/resources/css/imgs/Flags/Tahiti.png");
               case 'tayikistan':
               case 'tajikistan':
                    return require("../../assets/resources/css/imgs/Flags/Tajikistan.png");
               case 'tanzania':
                    return require("../../assets/resources/css/imgs/Flags/Tanzania.png");
               case 'tailandia':
               case 'thailand':
                    return require("../../assets/resources/css/imgs/Flags/Thailand.png");
               case 'taiwan':
                    return require("../../assets/resources/css/imgs/Flags/Taiwan.png");
               case 'timororiental':
                    return require("../../assets/resources/css/imgs/Flags/Timor-Leste.png");
               case 'togo':
                    return require("../../assets/resources/css/imgs/Flags/Togo.png");
               case 'tonga':
                    return require("../../assets/resources/css/imgs/Flags/Tonga.png");
               case 'trinidadytobago':
               case 'trinidadtobago':
                    return require("../../assets/resources/css/imgs/Flags/TrinidadTobago.png");
               case 'tunez':
               case 'túnez':
               case 'tunisia':
                    return require("../../assets/resources/css/imgs/Flags/Tunisia.png");
               case 'turquia':
               case 'turquía':
               case 'turkey':
                    return require("../../assets/resources/css/imgs/Flags/Turkey.png");
               case 'turkmenistan':
                    return require("../../assets/resources/css/imgs/Flags/Turkmenistan.png");
               case 'islasturcasycaicos':
                    return require("../../assets/resources/css/imgs/Flags/TurksCaicosIslands.png");
               case 'tuvalu':
                    return require("../../assets/resources/css/imgs/Flags/Tuvalu.png");
               case 'uganda':
                    return require("../../assets/resources/css/imgs/Flags/Uganda.png");
               case 'ucrania':
               case 'ukraine':
                    return require("../../assets/resources/css/imgs/Flags/Ukraine.png");
               case 'emiratosarabesunidos':
               case 'unitedarabemirates':
               case 'unitedarabemirates(uae)':
               case 'emirates':
                    return require("../../assets/resources/css/imgs/Flags/UnitedArabEmirates.png");
               case 'nacionesunidas':
               case 'unitednations':
                    return require("../../assets/resources/css/imgs/Flags/UnitedNations.png");
               case 'uzbekistan':
                    return require("../../assets/resources/css/imgs/Flags/Uzbekistan.png");
               case 'vanuatu':
                    return require("../../assets/resources/css/imgs/Flags/Vanutau.png");
               case 'ciudadvaticano':
               case 'vaticancity':
                    return require("../../assets/resources/css/imgs/Flags/VaticanCity.png");
               case 'vietnam':
                    return require("../../assets/resources/css/imgs/Flags/VietNam.png");
               case 'virgingislandsbritanicas':
               case 'islasvirgenesbritanicas':
                    return require("../../assets/resources/css/imgs/Flags/VirginIslandsBritish.png");
               case 'virginislandsus':
               case 'islasvirgenesdelosestadosunidos':
                    return require("../../assets/resources/css/imgs/Flags/VirginIslandsUS.png");
               case 'uzbekistan':
                    return require("../../assets/resources/css/imgs/Flags/Uzbekistan.png");
               case 'gales':
                    return require("../../assets/resources/css/imgs/Flags/Wales.png");
               case 'saharaoccidental':
                    return require("../../assets/resources/css/imgs/Flags/WesternSahara.png");
               case 'yemen':
                    return require("../../assets/resources/css/imgs/Flags/Yemen.png");
               case 'zambia':
                    return require("../../assets/resources/css/imgs/Flags/Zambia.png");
               case 'zimbabwe':
                    return require("../../assets/resources/css/imgs/Flags/Zimbabwe.png");
               case 'germany':
               case 'alemania':
                    return require("../../assets/resources/css/imgs/Flags/Germany.png");
               case 'argentina':
               case 'argentine':
                    return require("../../assets/resources/css/imgs/Flags/Argentina.png");
               case 'australia':
                    return require("../../assets/resources/css/imgs/Flags/Australia.png");
               case 'bélgica':
               case 'belgica':
               case 'belgium':
                    return require("../../assets/resources/css/imgs/Flags/Belgium.png");
               case 'bolivia':
                    return require("../../assets/resources/css/imgs/Flags/Bolivia.png");
               case 'brasil':
               case 'brazil':
                    return require("../../assets/resources/css/imgs/Flags/Brazil.png");
               case 'canadá':
               case 'canada':
                    return require("../../assets/resources/css/imgs/Flags/Canada.png");
               case 'chile':
                    return require("../../assets/resources/css/imgs/Flags/Chile.png");
               case 'china':
                    return require("../../assets/resources/css/imgs/Flags/China.png");
               case 'colombia':
                    return require("../../assets/resources/css/imgs/Flags/Colombia.png");
               case 'coreadelsur':
               case 'korea,republicof':
               case 'korea':
               case 'southkorea':
                    return require("../../assets/resources/css/imgs/Flags/SouthKorea.png");
               case 'coreadelnorte':
               case 'northkorea':
                    return require("../../assets/resources/css/imgs/Flags/NorthKorea.png");
               case 'costarica':
                    return require("../../assets/resources/css/imgs/Flags/CostaRica.png");
               case 'cuba':
                    return require("../../assets/resources/css/imgs/Flags/Cuba.png");
               case 'ecuador':
                    return require("../../assets/resources/css/imgs/Flags/Ecuador.png");
               case 'escocia':
               case 'scotland':
                    return require("../../assets/resources/css/imgs/Flags/Scotland.png");
               case 'españa':
               case 'spain':
                    return require("../../assets/resources/css/imgs/Flags/Spain.png");
               case 'estadosunidosdeamerica':
               case 'us':
               case 'unitedstatesofamerica':
               case 'unitedstatesofamerica(usa)':
               case 'unitedstates':
               case 'estadosunidos':
               case 'ee.uu.':
               case 'eeuu':
               case 'usa':
                    return require("../../assets/resources/css/imgs/Flags/EEUU.png");
               case 'finlandia':
               case 'finland':
                    return require("../../assets/resources/css/imgs/Flags/Finland.png");
               case 'francia':
               case 'france':
                    return require("../../assets/resources/css/imgs/Flags/France.png");
               case 'guatemala':
                    return require("../../assets/resources/css/imgs/Flags/Guatemala.png");
               case 'grecia':
               case 'greece':
                    return require("../../assets/resources/css/imgs/Flags/Greece.png");
               case 'holanda':
               case 'holland':
               case 'thenetherlands':
               case 'netherlands':
                    return require("../../assets/resources/css/imgs/Flags/Netherlands.png");
               case 'italia':
               case 'italy':
                    return require("../../assets/resources/css/imgs/Flags/Italy.png");
               case 'india':
                    return require("../../assets/resources/css/imgs/Flags/India.png");
               case 'inglaterra':
               case 'unitedkingdom':
               case 'unitedkingdom(uk)':
               case 'reinounido':
               case 'r.unido':
               case 'r-unido':
               case 'uk':
               case 'unitedkindom':
                    return require("../../assets/resources/css/imgs/Flags/UK.png");
               case 'irlanda':
               case 'ireland':
                    return require("../../assets/resources/css/imgs/Flags/Ireland.png");
               case 'israel':
                    return require("../../assets/resources/css/imgs/Flags/Israel.png");
               case 'japón':
               case 'japon':
               case 'japan':
                    return require("../../assets/resources/css/imgs/Flags/Japan.png");
               case 'noruega':
               case 'norway':
                    return require("../../assets/resources/css/imgs/Flags/Norway.png");
               case 'méxico':
               case 'mexico':
                    return require("../../assets/resources/css/imgs/Flags/Mexico.png");
               case 'peru':
               case 'perú':
                    return require("../../assets/resources/css/imgs/Flags/Peru.png");
               case 'panama':
               case 'panamá':
                    return require("../../assets/resources/css/imgs/Flags/Panama.png");
               case 'paraguay':
                    return require("../../assets/resources/css/imgs/Flags/Paraguay.png");
               case 'portugal':
                    return require("../../assets/resources/css/imgs/Flags/Portugal.png");
               case 'puertorico':
                    return require("../../assets/resources/css/imgs/Flags/PuertoRico.png");
               case 'poland':
               case 'polonia':
                    return require("../../assets/resources/css/imgs/Flags/Poland.png");
               case 'republicacheca':
               case 'czechrepublic':
                    return require("../../assets/resources/css/imgs/Flags/CzechRepublic.png");
               case 'rusia':
               case 'russianfederation':
               case 'russia':
                    return require("../../assets/resources/css/imgs/Flags/RussianFederation.png");
               case 'rumania':
               case 'romania':
                    return require("../../assets/resources/css/imgs/Flags/Romania.png");
               case 'suecia':
               case 'sweden':
                    return require("../../assets/resources/css/imgs/Flags/Sweden.png");
               case 'suiza':
               case 'switzerland':
                    return require("../../assets/resources/css/imgs/Flags/Switzerland.png");
               case 'uruguay':
                    return require("../../assets/resources/css/imgs/Flags/Uruguay.png");
               case 'venezuela':
                    return require("../../assets/resources/css/imgs/Flags/Venezuela.png");
               default:
                    if (country)

                         return require("../../assets/resources/css/imgs/Flags/Flag.png");
          }

     }


     render() {
          const {
               countryName,
               height
          } = this.props
          if (countryName == null || countryName == "") {
               return ( < > < />)
               }
                    var name = this.getCountryImage(countryName)

                    return < >
                         <
                              img alt=""
                              src={
                                   name
                              }
                              height={
                                   height
                              }

                         />

                         {
                    /* <img alt="" src={require('../../assets/resources/css/imgs/Flags/Brazil.png'))} />  */} <
               />
          }


     }

                         export default SpeakerFlag